import * as api from '@/api/products'
export default {
  state: {
    data: [],
    pagination: {},
    product:{},
  },

  mutations: {
    SET_PRODUCTS: (state, products) => {
      state.data = products.data
      state.pagination = products.pagination
    },

    SET_PRODUCT: (state, product) => {

      state.product = product
    },

    addToCart: (state, id) => {
      state.data.forEach(el => {
        if (id === el.id) {
          el.isAddedToCart = true
        }
      })
    },

    setAddedBtn: (state, data) => {
      state.data.forEach(el => {
        if (data.id === el.id) {
          el.isAddedBtn = data.status
        }
      })
    }
  },

  actions: {
    fetchProducts({ commit }, queryParams) {
      return new Promise((resolve, reject) => {
        api.fetch(queryParams)
          .then(({ data }) => {
            commit('SET_PRODUCTS', data)
            resolve(data)
          })
          .catch(e => reject(e))
      })
    },
    fetchProduct({ commit }, id) {
      console.log("fetchProduct");
      return new Promise((resolve, reject) => {
        api.fetchProduct(id)
          .then(({ data }) => {
            commit('SET_PRODUCT', data)
            resolve(data)
          })
          .catch(e => reject(e))
      })
    },
  }
}
